import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { InlinePopover } from './InlinePopover';
import { teamMembers } from '../../data/conditions';
import { getMember } from '../../utils/conditions';
interface AssigneeSelectProps {
  value: string;
  onChange: (id: string) => void;
  conditionName: string;
}
export function AssigneeSelect({
  value,
  onChange,
  conditionName
}: AssigneeSelectProps) {
  const current = getMember(value);
  return <InlinePopover ariaLabel={`Assigned to ${current.name} for ${conditionName}. Change assignee`} triggerClassName="group inline-flex items-center gap-0.5 p-0.5 hover:bg-slate-100" trigger={<>
          <Avatar member={current} data-id="element-4" data-mp="mh9prkfxut2m" />
          <ChevronDownIcon className="h-3.5 w-3.5 text-slate-400 group-hover:text-slate-600" aria-hidden="true" data-id="element-5" data-mp="mib2dtclrnmg" />
        </>} data-id="element-3" data-mp="wdmgqak3msto">
      {close => <ul role="listbox" aria-label="Assignee" className="w-60 rounded-md border border-slate-200 bg-white py-1 shadow-lg" data-id="element-6" data-mp="2gvaq69r4zo4t">
          {teamMembers.map(m => {
        const selected = m.id === value;
        return <li key={m.id} data-id="element-7" data-mp="1solo95k1ol4v">
                <button type="button" role="option" aria-selected={selected} onClick={() => {
            onChange(m.id);
            close();
          }} className="flex w-full items-center gap-2.5 px-3 py-2 text-left hover:bg-slate-50 focus:bg-slate-50 focus:outline-none" data-id="element-8" data-mp="1er6wvva8e3a9">
                  <Avatar member={m} size="sm" data-id="element-9" data-mp="1xqaxqgrmcqqu" />
                  <span className="min-w-0 flex-1" data-id="element-10" data-mp="1xpj77kcvpj7f">
                    <span className="block text-sm font-medium text-slate-800" data-id="element-11" data-mp="22o469gge9wua">{m.name}</span>
                    <span className="block text-xs text-slate-500" data-id="element-12" data-mp="2qdygrrd8r9bd">{m.role}</span>
                  </span>
                  {selected && <CheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-13" data-mp="2v68cjo11f3lk" />}
                </button>
              </li>;
      })}
        </ul>}
    </InlinePopover>;
}